import React from 'react';
import { Link } from 'react-router-dom';
import { serviceTracks } from '../../content/siteData';

function Services() {
  return (
    <main className="gop-page">
      <section className="gop-page-hero">
        <div className="gop-container">
          <span className="gop-eyebrow">Services</span>
          <h1>Support across the full international planning journey.</h1>
          <p>
            We help applicants at every major decision point, from early profile planning to final
            document review and submission support.
          </p>
        </div>
      </section>

      <section className="gop-page-section">
        <div className="gop-container gop-service-stack">
          {serviceTracks.map((item) => (
            <article key={item.title} className="gop-service-card">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="gop-mini-cta">
        <div className="gop-container gop-mini-cta__inner">
          <div>
            <h2>Want to know which service matters first for your case?</h2>
            <p>We can help sequence your next steps instead of overwhelming you with everything at once.</p>
          </div>
          <Link to="/contact" className="gop-btn gop-btn--primary">
            Book Free Counselling
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Services;
